"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRICES = exports.OLD_PRICE = exports.CURRENT_PRICE = void 0;
const PRICES = exports.PRICES = 'prices';
const CURRENT_PRICE = exports.CURRENT_PRICE = 'current-price';
const OLD_PRICE = exports.OLD_PRICE = 'old-price';
//# sourceMappingURL=constants.js.map